<button [ngClass]="theClass" class="icon-button">
    
    <span *ngIf="theIcon != null" class="mr-1">
        <fa-icon [icon]="theIcon"></fa-icon>
    </span>
    <span>{{text}}</span>
</button>